<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="ABASTECIMENTOS SINTÉTICO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" 
            :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" 
            colSpanPDF="6" :totalPDF="total" :totalHide="true" :titleReport="titleReport">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Empresa, Fornecedor ou Carro" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell v-if="item.carro_id" class="uppercase" md-label="CARRO" style="width: 60%">{{ item.carro }}</md-table-cell>
                        <md-table-cell v-if="!item.carro_id" class="uppercase" md-label="CARRO" style="width: 60%"><strong>{{ item.carro }}</strong></md-table-cell>
                        <md-table-cell v-if="item.carro_id" class="uppercase" md-label="PLACA" style="width: 20%">{{ item.placa }}</md-table-cell>
                        <md-table-cell v-if="!item.carro_id" md-label="PLACA" style="width: 20%"><strong>{{ item.placa }}</strong></md-table-cell>
                        <md-table-cell v-if="item.carro_id" md-label="VALOR" style="width: 20%">{{ item.valor }}</md-table-cell>
                        <md-table-cell v-if="!item.carro_id" md-label="VALOR" style="width: 20%"><strong>{{ item.valor }}</strong></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify';
import Pagamento from '@/config/mixins/print/pagamento';
import getDateFormat from '@/config/mixins/getDateFormat';
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            titleReport: '',
            columnsPDF: [120, 30, 30],
            headRowsPDF: ['CARRO', 'PLACA', 'VALOR'],
            bodyRowsPDF: ['carro', 'placa', 'valor'],
            fildsTXT: ['carro', 'placa', 'valor_txt'],
            columnsExcel: [

                {
                    label: "CARRO",
                    field: "carro",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "PLACA",
                    field: "placa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel:[],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento, getDateFormat],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.titleReport = 'Relatório de abastecimento sintético - Período ' 
            + this.getDataInicial(this.buscar.dataInicial) + ' a ' + this.getDataFinal(this.buscar.dataFinal)
            this.$http.post(this.$urlAPI + 'abastecimentos/sintetico', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf_placa, item.data_pagamento, item.valor]).includes(this.toLower(term)))
            }
            return items
        }
    },

};
</script>
<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
